import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardColumns';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductCards = ({
  columns,
  hasBadgeOnFirstColumn = false,
  hasBadgeOnLastColumn = false,
  children
}) => {
  return /*#__PURE__*/_jsx(PageSection, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx(MerchCardColumns, {
      hasBadgeOnFirstColumn: hasBadgeOnFirstColumn,
      hasBadgeOnLastColumn: hasBadgeOnLastColumn,
      columns: columns,
      children: children
    })
  });
};